import React from 'react';
import { TDirection, TPosition } from '../../../types/types';

interface IFlexCenterProps {
    children?: React.ReactNode;
    gap?: number;
    direction?: TDirection;
    position?: TPosition;
    stretch?: boolean;
    isRelative?: boolean;
}

export const FlexCenter: React.FC<IFlexCenterProps> = ({ isRelative = false, children, gap = 1, direction = 'h', position = 'center', stretch = false }) => {
    return (
        <div className={`flex-center-layout ${stretch && 'flex-center-layout__stretch'} flex-center-layout__${direction} flex-center-layout__${direction}--${position}`} style={{ gap: `${gap}rem`}}>
            {children}
        </div>
    );
};
